import React, {Component} from 'react';
import {
    Row,
} from 'reactstrap';

import GeneralForm from "./forms/GeneralForm";

class GeneralFrame extends Component {
    render() {
        return (
            <div>
                <Row>
                    <h3>Just a few more questions for you</h3>
                </Row>
                <hr/>
                <p>These are a few important things landlords need to know. Don't worry, if you answer "yes" to any of these, we give you a chance to explain the situation so that landlords see the
                    full story.</p>
                <p>Answer these truthfully -- it's not hard for landlords to check your answers.</p>
                <hr/>
                <GeneralForm/>
            </div>
        );
    }
}

export default GeneralFrame;



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/GeneralFrame.js